import { PLAN } from '@/common/constants/markets';
import { ROUTES } from '@/common/constants/routes';
import { useMarket } from '@/common/hooks/useMarket';
import { Redirect } from 'expo-router';
import { PTMealHomePage } from './PTMealHomePage/PTMealHomePage';
import { PTWalletHomePage } from './PTWalletHomePage/PTWalletHomePage';

export function PTHomePage() {
  const { plan } = useMarket();
  switch (plan) {
    case PLAN.SUC_MEAL:
      return <PTMealHomePage />;
    case PLAN.WALLET:
      return <PTWalletHomePage />;
    default:
      return <Redirect href={ROUTES.NOT_FOUND} />;
  }
}
